<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--培训项目-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">报考专业</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="xmList" @change="getKcList" text-field="mc" value-field="id" v-model="query.xmId" placeholder="-报考专业筛选-" :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--课程-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
                                <BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc"
                                                   v-model="query.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--考生关键字-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label id="ksks" class="col-sm-3 control-label">考生关键字</label>
                            <div class="col-sm-9">
                                <input type="text" name="keyword" v-model="query.keyword" class="form-control"
                                       placeholder="">
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
                    <div class="col-sm-6">
                        <div class="pull-right">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>查询
                            </button>
                            <button @click="dc()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-left: 12px"><i class="fa fa-download" aria-hidden="true"></i>导出
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /**
     * 课件学习-学生观看情况
     */
    import tableMixin from '@/mixins/table.js';  //表格
    import qs from "qs";

    export default {
        mixins: [tableMixin],
        name: "KjxxLearningQkList",
        data: function () {
            return {
                kcList: [],
                dwList: [],
                xmList: [],
                List: [],
                query: {
                    xmId: '',
                    kcId: '',
                    dwId: '',
                    keyword: '',
                },
                columns: [
                    {
                        field: 'state',
                        checkbox: true
                    },
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index) => {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'pxzt',
                        title: '报考专业',
                        formatter: (value, row) => {
                            return row.xmbh + '-' + value;
                        }
                    },
                    {
                        field: 'xm',
                        title: '姓名'
                    },
                    {
                        field: 'sfzh',
                        title: '身份证号'
                    },
                    // {
                    //     field: 'dwmc',
                    //     title: '学员单位',
                    //     formatter: (value, row) => {
                    //         if (row.jgdm && row.jgmc) {
                    //             return row.jgdm + "-" + row.jgmc;
                    //         }
                    //     }
                    // },
                    {
                        field: 'kcmc',
                        title: '课程'
                    },
                    {
                        field: 'kjsc',
                        title: '课件总时长（分钟）'
                    },
                    {
                        field: 'gksc',
                        title: '观看时长（分钟）'
                    },
                    {
                        field: 'xxjd',
                        title: '学习进度',
                        formatter: (value, row) => {
                            return value + "%";
                        }
                    },
                    {
                        field: 'fs',
                        title: '成绩'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template:
                                    '<div class="operation_column"><a @click="detail(row)">详情</a>' +
                                    '</div>',
                                data: {row},
                                methods: {
                                    detail: this.detail
                                }
                            })
                        }
                    }
                ]
            }
        },
       mounted(){
       	this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
       	this.load();
       },
       beforeRouteUpdate(to, from, next){
		 this.query = Object.assign(this.query,{current:1,size:10},to.query);
       	this.load();
       	next();
       },
        created: function () {
            this.$store.commit('setBreadcrumb', [ {name: '自学考试'}, {name: '日常练习管理'}, {name: '课件学习管理'}]);
            // this.getqyList();
            this.getpcList();

        },
        methods: {
			formatOption:function(item){
				return item.jgdm+"-"+item.jgmc;
			},
            getKcList: function () {
                this.query.kcId = '';
                this.$http.post("/htgl/biz/zypx/kjxx/gkqk/hqkc", {xmId: this.query.xmId}).then(res => {
                    this.kcList = res.data || [];
                });
            },
            search: function () {
               //将数据表格的页码以及每一页展示的数据重置为1，10
               let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
               this.$router.push({name:this.$route.name,query:query});
            },
            //培训项目列表
            getpcList: function () {
                this.$http.post('/htgl/biz/zypx/kjxx/gkqk/hqpc').then(res => {
                    this.xmList = res.data;
                });
            },
            //获取学员单位列表
            // getqyList: function () {
            //     this.$http.post('/htgl/biz/zypx/kjxx/gkqk/hqqy').then(res => {
            //         this.dwList = res.data || [];
            //     });
            // },
            detail: function (row) {
				this.$router.push({name:'KjxxLearningQkDetail',query:{
					xmId: row.xm_id,
					kjId: row.id,
					ksId: row.ks_id,
					pxzt: row.pxzt,
					kjsc: row.kjsc,
					kcmc:row.kcmc
				}});
            },
            //导出
            dc: function () {
                this.$confirm('即将根据查询条件导出数据，确定执行此操作吗', (cid) => {
                    window.open('/htgl/biz/zypx/kjxx/gkqk/dc?' + qs.stringify(this.query));
                });
            },
            load: function (pageNumber, pageSize) {
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/zypx/kjxx/gkqk/cx', this.query).then(res => {
                    let data = res.data;
                    console.log(data)
                    //封装返回值
                    let result = {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange: function (pageNumber, pageSize) {
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }

    }
</script>
<style scoped>

</style>
